import StoresPage from "./StoresPage";
import withStores from "../WithStores";

export default withStores(StoresPage);
